import { useState } from 'react';
import { faEdit, faFilter, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Table, Button, Popconfirm, Space } from 'antd';
import { ColumnType } from 'antd/es/table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomTitle from '../../components/CustomTitle';
import ButtonIcon from '../../components/ButtonComp';
import CustomLayout from 'components/Layout';

type Turno = {
    id: number;
    user: string;
    start_date: string;
    end_date: string;
    status: string;
};

const TurnoManagement = () => {
    const [turnos, setTurnos] = useState<Turno[]>([
        {
            id: 1,
            user: 'Juan Pérez',
            start_date: '2025-01-27 08:00',
            end_date: '2025-01-27 16:00',
            status: 'Activo',
        },
        {
            id: 2,
            user: 'María García',
            start_date: '2025-01-27 09:00',
            end_date: '2025-01-27 17:00',
            status: 'Activo',
        },
        {
            id: 3,
            user: 'Pedro González',
            start_date: '2025-01-28 08:00',
            end_date: '2025-01-28 16:00',
            status: 'Inactivo',
        },
    ]);

    // Función para eliminar un turno
    const handleDelete = (id: number) => {
        setTurnos(turnos.filter((turno) => turno.id !== id));
    };

    // Función para editar un turno (esta puede abrir un modal, por ejemplo)
    const handleEdit = (id: number) => {
        console.log(`Editando turno con ID: ${id}`);
        // Aquí podrías abrir un modal de edición con los datos del turno.
    };

    // Configuración de las columnas para la tabla
    const columns: ColumnType<Turno>[] = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Usuario',
            dataIndex: 'user',
            key: 'user',
        },
        {
            title: 'Fecha de inicio',
            dataIndex: 'start_date',
            key: 'start_date',
        },
        {
            title: 'Fecha de fin',
            dataIndex: 'end_date',
            key: 'end_date',
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Acciones',
            key: 'actions',
            render: (_, record: Turno) => (
                <Space size="middle">
                    <Button
                        icon={<FontAwesomeIcon icon={faEdit} />}
                        onClick={() => handleEdit(record.id)}
                        type="primary"
                        size="small"
                        title="Editar turno"
                    />
                    <Popconfirm
                        title="¿Seguro que quieres eliminar este turno?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Sí"
                        cancelText="No"
                    >
                        <Button
                            icon={<FontAwesomeIcon icon={faTrash} />}
                            type="dashed"
                            size="small"
                            title="Eliminar turno"
                        />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <CustomLayout>
            <CustomTitle
                title='Gestión de Turnos'
                actions={[
                    <ButtonIcon icon={faFilter} tooltip='Filtrar resultados' variant='outline-primary'/>
                ]}
            />
            <Table
                columns={columns}
                dataSource={turnos}
                rowKey="id"
                pagination={{ pageSize: 5 }}
            />
        </CustomLayout>
    );
};

export default TurnoManagement;
